document.addEventListener("DOMContentLoaded", function() {
  $(document).on("click", ".myModal .close", function(event) {
      event.preventDefault();
      event.stopPropagation();

      $('.myModal').css('display', 'none');
      $(event.target).closest('.product-card__content').find('.myModal').removeClass('open');
      $("body").css("overflow", "auto");
  });
});

(async function(algolia) {
  'use strict';

  if (!algolia.config.autocomplete_enabled) return;

  //const client = algoliarecommend(algolia.config.app_id, algolia.config.search_api_key);

  const autocomplete = algolia.externals.autocomplete;

  const index_suffix = await algolia.config.index_suffix;

  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  if (algolia.config.dynamic_selector) {
    const search_url = algolia?.shopify?.routes?.search_url || `${window.Shopify.routes.root}/search`;
    const default_form_search = `form[action="${search_url}"]`;
    algolia.config.input_selector += `, ${default_form_search}`;
  }
  
  // Retrieve the container from Shopify's config
  const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
  containers.forEach(container => {
    container.innerHTML = ''
    const containerClasses = container.classList;
    containerClasses.add('aa-MainContainer');
  });

  const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
    key: 'qs-with-rs-example',
    limit: 3,
    transformSource({ source }) {
      return {
        ...source,
        getItemUrl({ item }) {
          return `/search?q=${item.query}`;
        },
        templates: {
          item(params) {
            const { item, html } = params;

            return html`<a class="aa-ItemLink" href="/search?q=${item.id}">
              ${source.templates.item(params).props.children}
            </a>`;
          },
        },
      };
    },
  });

  const { createRedirectUrlPlugin } = window['@algolia/autocomplete-plugin-redirect-url'];

  const redirectUrlPlugin = createRedirectUrlPlugin();
  // Set plugins
  const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin, collectionsEmptyPlugin, productsEmptyPlugin, querySuggestionsEmptyPlugin } = algolia;
  const plugins = [
    algolia.config.index_products && productsPlugin,
    algolia.config.index_collections && collectionsPlugin,
    algolia.config.index_articles && articlesPlugin,
    algolia.config.index_pages && pagesPlugin,
    algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin,
    recentSearchesPlugin,
    collectionsEmptyPlugin,
    productsEmptyPlugin,
    querySuggestionsEmptyPlugin,
    redirectUrlPlugin
  ];

  const cssFile = document.getElementById('template_algolia_autocomplete.css');
  //Set CSS variables
  document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
  document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
  document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
  document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  //Link CSS
  algolia.appendStyle(cssFile.text);

  function checkEmpty(obj) {
    // Define an array with the expected keys
    const expectedKeys = ["collections_empty", "products_empty", "suggestions_empty"];
    
    // Check if the object has exactly three keys and they match the expected keys
    return obj.length === 3 && obj.every(key => expectedKeys.includes(key.source.sourceId));
  }

  let swiperProducts = '';

  const autocompleteOptions = {
    openOnFocus: true,
    debug: algolia.config.autocomplete_debug,
    insights: algolia.config.analytics_enabled,
    placeholder: 'Search for products...',
    detachedMediaQuery: '(min-width: 1px)',
    plugins,
    render({ elements, render, html, state }, root) {
      
      const sourceIdsToExclude = ['products'];
      const hasLeftPanelResults = state.collections
              .filter(
                      ({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1
              )
              .reduce((prev, curr) => prev + curr.items.length, 0) > 0;
      const [querySuggestionsPluginResults] = state.collections.filter(({source}) => source.sourceId === 'querySuggestionsPlugin');
      const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;

      const isEmpty = checkEmpty(state.collections.filter(({items}) => items.length > 0));

      render(
        isEmpty ? algolia.noResultsTemplate({ html, state }, elements, displaySuggestions) :
              hasLeftPanelResults ?
              algolia.mainTemplate({ html, state }, elements, displaySuggestions)
              : algolia.mainProductsTemplate({ html, state }, elements),
              root
      );

      if(window.innerWidth <= 1080) {
        if(!state.query || isEmpty) {
          swiperProducts = new Swiper('.aa-PanelSection--trending-products .aa-Source', {
              wrapperClass: 'aa-List',
              slideClass: 'aa-Item',
              slidesPerView: 2,
              navigation: {
                  nextEl: '.aa-PanelSection--trending-products .slider__arrow--next',
                  prevEl: '.aa-PanelSection--trending-products .slider__arrow--prev',
              }
          });

          if(!isEmpty) {
            new Swiper('.aa-PanelSections--footer-wrapper', {
                wrapperClass: 'aa-PanelSections--footer-body',
                slideClass: 'aa-PanelSections--faq-block',
                slidesPerView: 1.2,
                spaceBetween: 16,
                navigation: {
                    nextEl: '.aa-PanelSections--footer .slider__arrow--next',
                    prevEl: '.aa-PanelSections--footer .slider__arrow--prev',
                }
            });
          }
        }else {
          if(swiperProducts) {
            swiperProducts.destroy(true, true);
            swiperProducts = '';
          }
        }
      }
      const chatNowBtn = document.querySelector('.chat-now');

      if(chatNowBtn) {
        chatNowBtn.addEventListener('click', (e) => {
          e.preventDefault();
          document.querySelector('.aa-DetachedFormContainer .aa-DetachedCancelButton')?.click();
          activeZendesk();
        })
      }
    },
    onStateChange({ state }) {
    },
    renderNoResults({ render, html, state }, root) {
      render(
              algolia.noResultsTemplate({ html, state }),
              root
      )
    },
    onSubmit({ state }) {
      window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(state.query)}`;
    }
  }
  
  containers.forEach(container => {
    const auto = autocomplete({
      container,
      ...autocompleteOptions
    });
  });

  document.querySelectorAll('#header-search__open').forEach(i => {
    i.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const searchInput = document.querySelector('.aa-DetachedSearchButton');

      if(searchInput)
        searchInput.click();
    })
  })
})(window.algoliaShopify);
